import Page from "components/Page";
import PageBody from "components/PageBody";
import PageHead from "./PageHead";
import MyPublications from "../../Dashboard/MyPublications";
import MyFarmGroups from "../../Dashboard/MyFarmGroups";
import { useMyPublicationsSummary, useMyRecentPublications } from "containers/Reporting/_hooks";
import { useMyFarmGroups } from "containers/hooks";
import { useModal } from "common/effects";
import { v4 as uuidv4 } from "uuid";
import CreateFarmGroupModal from "containers/FarmGroups/CreateFarmGroupModal";
import * as icons from "common/icons";
import { Panel, PanelBody } from "components/Panel";
import ActionLink from "components/ActionLink";
import { Link } from "react-router-dom";

export default function Portfolio() {
    const { isLoading: myPublicationsSummaryLoading, data: myPublicationsSummary } = useMyPublicationsSummary();
    const { isLoading: myRecentPublicationsLoading, data: myRecentPublications } = useMyRecentPublications();
    const { isLoading: myFarmGroupsLoading, isFetching: myFarmGroupsFetching, data: myFarmGroups } = useMyFarmGroups();
    const farmGroupData = myFarmGroups?.filter((farmGroup) => farmGroup.role === "Admin") || [];
    const hasPublicationsSummary = myPublicationsSummary?.length > 0;
    const hasRecentPublications = myRecentPublications?.length > 0;

    const { openModal, getModal } = useModal();

    const createFarmGroup = () => {
        const viewModel = {
            id: uuidv4(),
            showMembers: true,
            showAggregatedReport: true,
            showBenchmarkReport: true,
        };
        openModal("CreateFarmGroup", { viewModel });
    };
    const createFarmGroupModal = getModal("CreateFarmGroup");

    return (
        <>
            <Page>
                <PageHead createFarmGroup={createFarmGroup} />
                <PageBody>
                    {!hasPublicationsSummary && !hasRecentPublications && farmGroupData.length === 0 ? (
                        <Panel title="Portfolio reporting" iconClassName="IconLink--bookmarks" loading={myFarmGroupsLoading || myFarmGroupsFetching}>
                            <PanelBody loading={myFarmGroupsLoading || myFarmGroupsFetching}>
                                <div className="Tile-body-message">
                                    <img className="u-p-5" src={icons.info} alt="Plus" />
                                    <p className="lead">You do not have any publications or farm groups</p>
                                    <Link to="/" id="dashboard-link" className="IconLink--home Button Button--lg u-mt-xl">
                                        Back to dashboard
                                    </Link>
                                    <ActionLink onClick={createFarmGroup} id="add-link" className="IconLink--arrow-plus Button Button--lg u-mt-md">
                                        Create farm group
                                    </ActionLink>
                                </div>
                            </PanelBody>
                        </Panel>
                    ) : (
                        <>
                            {hasPublicationsSummary || hasRecentPublications ? (
                                <MyPublications myPublicationsSummaryLoading={myPublicationsSummaryLoading} myPublicationsSummary={myPublicationsSummary} myRecentPublicationsLoading={myRecentPublicationsLoading} myRecentPublications={myRecentPublications} />
                            ) : (
                                <Panel title="Publications" iconClassName="IconLink--bookmarks" loading={myPublicationsSummaryLoading || myRecentPublicationsLoading}>
                                    <PanelBody loading={myPublicationsSummaryLoading || myRecentPublicationsLoading}>
                                        <div className="Tile-body-message u-mt-md u-mb-xl">
                                            <img className="u-p-5" src={icons.info} alt="Plus" />
                                            <p className="lead">You do not have any publications</p>
                                            <Link to="/" id="dashboard-link" className="IconLink--home Button Button--lg u-mt-xl">
                                                Back to dashboard
                                            </Link>
                                        </div>
                                    </PanelBody>
                                </Panel>
                            )}

                            {farmGroupData.length > 0 ? (
                                <MyFarmGroups isLoading={myFarmGroupsLoading} isFetching={myFarmGroupsFetching} myFarmGroups={myFarmGroups} createFarmGroup={createFarmGroup} />
                            ) : (
                                <Panel title="Farm groups" iconClassName="IconLink--bookmarks" loading={myFarmGroupsLoading || myFarmGroupsFetching}>
                                    <PanelBody loading={myFarmGroupsLoading || myFarmGroupsFetching}>
                                        <div className="Tile-body-message u-mt-md u-mb-xl">
                                            <img className="u-p-5" src={icons.add} alt="Plus" />
                                            <p className="lead">You do not have any farm groups</p>
                                            <ActionLink onClick={createFarmGroup} id="add-link" className="IconLink--add Button Button--lg u-mt-xl">
                                                Create farm group
                                            </ActionLink>
                                        </div>
                                    </PanelBody>
                                </Panel>
                            )}
                        </>
                    )}
                </PageBody>
            </Page>
            {createFarmGroupModal && <CreateFarmGroupModal {...createFarmGroupModal.modalProps} />}
        </>
    );
}
